import axios, { AxiosPromise } from 'axios';
import { IBatch } from '../../../@types/model/batch/batch';
import { ILotRelatedData } from '../../../@types/model/lot/lotRelatedData';
import qs from 'qs';
import { IBatchSummaryRelatedData } from '../../../@types/model/batch/batchSummaryRelatedData';
import { IBatchView } from '../../../@types/model/batch/batchView';
import { IBatchViewRelatedData } from '../../../@types/model/batch/batchViewRelatedData';
import { IBatchReportRelatedData } from '../../../@types/model/batch/batchReportRelatedData';
import { IBatchIdCode } from '../../../@types/model/batch/batchidcode';
import { IMultiBatchReportData } from '../../../@types/model/batch/multiBatchReportData';
import { IBatchAppView } from '../../../@types/model/batch/batchAppView';

export default class BatchHttpService {
    public static getBatchData() : AxiosPromise<Array<IBatch>> {
        return axios.get(`${API_URL}/v1/Batch/GetAllWeb`);
    }

    public static getBatchAppView(batchGuid : string) : AxiosPromise<IBatchAppView> {
        return axios.get(`${API_URL}/v1/Batch/GetAppBatch`, {
            params: {
                batchGuid,
            },
        });
    }

    public static getMultiBatchReportData(data : IMultiBatchReportData) : AxiosPromise<Array<IBatchIdCode>> {
        return axios.post(`${API_URL}/v1/Batch/GetMultiBatchReportData`, data);
    }

    public static addOrUpdateBatch(data : IBatch) : AxiosPromise<IBatch> {
        return axios.post(`${API_URL}/v1/Batch/PostBatch`, data);
    }

    public static addOrchardsToBatch(batchId : number, orchardIds : Array<number>) : AxiosPromise<IBatchView> {
        return axios.post(`${API_URL}/v1/Batch/AddOrchardsToBatch`, {
            batchId,
            orchardIds,
        });
    }

    public static addDepartmentsToBatch(batchId : number, departmentIds : Array<number>) : AxiosPromise<IBatchView> {
        return axios.post(`${API_URL}/v1/Batch/AddDepartmentsToBatch`, {
            batchId,
            departmentIds,
        });
    }

    public static endBatch(batchId : number) : AxiosPromise<IBatchView> {
        return axios.post(`${API_URL}/v1/Batch/EndBatchWeb`, { batchId });
    }

    public static endMultiBatch(batchIds : Array<number>) : AxiosPromise<Array<IBatchView>> {
        return axios.post(`${API_URL}/v1/Batch/EndMultiBatchWeb`, { batchIds });
    }

    public static resumeBatch(batchId : number) : AxiosPromise<IBatchView> {
        return axios.post(`${API_URL}/v1/Batch/ResumeBatchWeb`, { batchId });
    }

    public static getBatchTransactionData(fromDateUnix ?: number, toDateUnix ?: number, siteIds ?: Array<number>, loadMasterData ?: boolean) : AxiosPromise<ILotRelatedData> {
        return axios.get(`${API_URL}/v1/Batch/WebTransactions`, {
            params: {
                fromDateUnix,
                toDateUnix,
                siteIds,
                loadMasterData,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static getBatchViews(fromDateUnix ?: number, toDateUnix ?: number, siteIds ?: Array<number>, loadMasterData ?: boolean, batchId ?: number) : AxiosPromise<IBatchViewRelatedData> {
        return axios.get(`${API_URL}/v1/Batch/WebTransactionViews`, {
            params: {
                fromDateUnix,
                toDateUnix,
                siteIds,
                loadMasterData,
                batchId,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static getBatchView(id ?: number) : AxiosPromise<IBatch> {
        return axios.get(`${API_URL}/v1/Batch/GetBatchView`, {
            params: {
                id,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static getBatchesToEnd(fromDateUnix ?: number, toDateUnix ?: number, siteIds ?: Array<number>) : AxiosPromise<Array<IBatch>> {
        return axios.get(`${API_URL}/v1/Batch/GetBatchesAvailableToEnd`, {
            params: {
                fromDateUnix,
                toDateUnix,
                siteIds,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static getBatchSummaryRelatedData(batchId ?: number, loadMasterData ?: boolean) : AxiosPromise<IBatchSummaryRelatedData> {
        return axios.get(`${API_URL}/v1/Batch/SummaryData`, {
            params: {
                batchId,
                loadMasterData,
            },
        });
    }

    public static getBatchReportRelatedData(batchId ?: number, loadMasterData ?: boolean) : AxiosPromise<IBatchReportRelatedData> {
        return axios.get(`${API_URL}/v1/Batch/GetReportRelatedData`, {
            params: {
                batchId,
                loadMasterData,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static getMultiBatchReportRelatedData(batchIds : Array<number>, loadMasterData ?: boolean) : AxiosPromise<IBatchReportRelatedData> {
        return axios.get(`${API_URL}/v1/Batch/GetMultiReportRelatedData`, {
            params: {
                batchIds,
                loadMasterData,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static deleteBatch(batchId : number, deleteReason : string) : AxiosPromise<IBatchView> {
        return axios.delete(`${API_URL}/v1/Batch/Delete`, {
            params : {
                batchId,
                deleteReason,
            },
        });
    }
}
